












































import { defineComponent, onBeforeMount } from '@vue/composition-api';
import { ITableOptions } from '@/bundles/BaseTable/interfaces';
import { warmUpHeadersData } from '@/bundles/WarmUp/helpers';
import { usePractice } from '@/composition-functions/usePractice';
import { useStore } from '@/utils/use-store';
import { useExercises } from '@/views/Question/QuestionsList.vue';

import BaseTable from '@/bundles/BaseTable/components/BaseTable.vue';
import QuestionsForm from '@/components/Questions/QuestionsForm.vue';
import { useCategoryList } from '@/composition-functions/useCategory';
import { Exercise } from '@/helpers/types';

export default defineComponent({
  name: 'WarmUpList',

  components: {
    BaseTable,
    QuestionsForm,
  },

  emits: ['options:change', 'items:refresh'],

  props: {
    tableOptionsEntry: {
      type: Object,
      required: true,
    },
    itemsEntry: {
      type: Array,
      default: () => [],
    },
    totalRowsEntry: {
      type: Number,
      default: 0,
    },
    loading: Boolean,
  },

  setup: function (props, { emit }) {
    const store = useStore();
    const { accessToken: token } = store.state.user;

    const {
      practiceList,
      fetchPractice,
    } = usePractice(token);
    const { fetchCategories } = useCategoryList();
    const {
      exerciseDrawer,
      tempExercise,
      requestPending,
      mode,
      closeEventHandler,
      updateExercise,
      fetchExercises,
      archiveExercise,
    } = useExercises(token);

    onBeforeMount(beforeMountEventHandler);

    /**
     * Handler for before mount event
     * */
    async function beforeMountEventHandler() {
      try {
        await fetchCategories(token);
        await fetchExercises(token);
        await fetchPractice();
      } catch (e) {
        throw e;
      }
    }

    function calculateHeight() {
      const total = window.innerHeight;
      const header = document.querySelector('.v-app-bar--fixed');
      const elementsHeight = (header as HTMLElement)?.offsetHeight + 70 + 64;
      // @ts-ignore
      return total - elementsHeight - (this.$vuetify.breakpoint.xs ? -55 : 0);
    }

    function optionsChangeEventHandler(options: ITableOptions) {
      emit('options:change', options);
    }

    function toggleEdit(id: null) {
      tempExercise.value = Object.assign({}, props.itemsEntry.find((exercise: any) => exercise.id === id)) || null;
      mode.value = 'edit';
      exerciseDrawer.value = true;
    }

    async function edit({ exercise, id }: { exercise: any, id: number }) {
      await updateExercise({ exercise, id });
      emit('items:refresh');
    }

    return {
      warmUpHeadersData,
      exerciseDrawer,
      tempExercise,
      requestPending,
      mode,
      practiceList,
      closeEventHandler,
      archiveExercise,
      edit,
      toggleEdit,
      calculateHeight,
      optionsChangeEventHandler,
    };
  },
});
